var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{staticClass:"h-100"},[_c('table-view',{staticClass:"search-bar",attrs:{"scrId":_vm.scrId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }